import { GameCard } from '@optools/components/game-card';
import { BtcScheduleGame } from '@optools/services/operator-gateway/btc/types';
import { Link } from '@tanstack/react-router';

import { PipelineList } from './pipeline-list';

export interface BTCGameCardProps {
  date: string;
  game: BtcScheduleGame;
}

export function BTCGameCard({ date, game }: BTCGameCardProps) {
  const { away, gamePk, home, pipelines } = game;

  return (
    <GameCard
      className="relative isolate overflow-hidden bg-(--pipelines-container-color) transition-colors [--pipelines-container-color:var(--color-card)] has-[>div>a:first-of-type:hover]:[--pipelines-container-color:var(--color-accent)]"
      data-testid={`game-${gamePk}`}
      game={game}>
      <Link
        className="absolute inset-0"
        from="/"
        params={{ gamePk }}
        search={{ date }}
        to="/btc-tools/schedule/$gamePk/pipelines"
      />

      {pipelines?.length ? (
        <section>
          <h3 className="mb-2 w-max font-bold">Pipelines</h3>
          <PipelineList away={away} gamePk={gamePk} home={home} pipelines={pipelines} />
        </section>
      ) : null}
    </GameCard>
  );
}
